import { render, staticRenderFns } from "./FaqCategoryBox.vue?vue&type=template&id=21317abc&"
import script from "./FaqCategoryBox.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports